import { DARK_BLUE_COLOR, DEFAULT_FONTFAMILY } from 'theme/theme';

export const formTitle = {
  height: 24,
  color: DARK_BLUE_COLOR,
  font: `500 12px/24px ${DEFAULT_FONTFAMILY}`,
  textTransform: 'uppercase',
  marginTop: 30,
};
